/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfileViewResponse } from '../models/ProfileViewResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProfileService {
    /**
     * Self Profile
     * @returns ProfileViewResponse Successful Response
     * @throws ApiError
     */
    public static selfProfileApiProfileSelfGet(): CancelablePromise<ProfileViewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profile/self',
        });
    }
    /**
     * Profile
     * @param userId
     * @returns ProfileViewResponse Successful Response
     * @throws ApiError
     */
    public static profileApiProfileUserIdGet(
        userId: string,
    ): CancelablePromise<ProfileViewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profile/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Share Photos
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static sharePhotosApiProfileUserIdSharePhotosPost(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/{user_id}/share-photos',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unshare Photos
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unsharePhotosApiProfileUserIdUnsharePhotosPost(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/{user_id}/unshare-photos',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Request Photos
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static requestPhotosApiProfileUserIdRequestPhotosPost(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/{user_id}/request-photos',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
